/**
 * «Применить шаблон» → «Только внешний вид» (WEB-4144; задание
 * WEB-4143+WEB-4144, «Решено за тебя» п. 8; решение владельца 02.11): правка
 * одной части воронки — настройки и экраны, одной записью двери вида
 * (`editLook` карты, действие `applyTemplateLook` окна у экрана).
 *
 * Собрана из тех же чистых функций, что выбор стиля, темы и шрифта:
 *  - пак — первый свой пак шаблона `stylePackIds[0]` через `withLookChoice`
 *    (слой размеров сайта «Оригинал» снимается, как при выборе другого стиля);
 *    своих паков нет — пак не меняется;
 *  - тема — `settings.themeId` шаблона через `withTheme`; «Оставить» свои
 *    цвета (`keepColors`) — тема не меняется, и пак свою тему не ставит
 *    (признак «цвета трогали» на время смены пака поднят, потом прежний);
 *  - шрифт — `settings.fontId` шаблона через `withFunnelFontId`;
 *  - `templateId` — шаблон воронки (заголовок окна, «Стили шаблона»).
 * Тема и шрифт не строкой — не меняются. Тексты и экраны (кроме полей слоя)
 * не трогаются.
 */
import { withFunnelFontId, withTheme } from './appearanceEdits';
import { withLookChoice } from './originalLook';

export interface TemplateLookSource {
  id: string;
  settings?: Record<string, unknown>;
  stylePackIds: readonly string[];
}

type Rec = Record<string, unknown>;

export function withTemplateLook<S extends object, C extends readonly unknown[]>(
  settings: S,
  screens: C,
  tpl: TemplateLookSource,
  opts: { keepColors: boolean },
): { settings: S & { templateId: string }; screens: C } {
  let next: Rec = settings as Rec;
  let nextScreens = screens;
  const pack = tpl.stylePackIds[0];
  if (pack) {
    const before = next;
    const base = opts.keepColors ? { ...before, colorsTouched: true } : before;
    const r = withLookChoice(base, screens, pack);
    nextScreens = r.screens;
    next = r.settings;
    if (opts.keepColors) {
      const { colorsTouched: _t, ...rest } = next;
      next =
        'colorsTouched' in before ? { ...rest, colorsTouched: before.colorsTouched } : rest;
    }
  }
  const themeId = tpl.settings?.themeId;
  if (!opts.keepColors && typeof themeId === 'string') next = withTheme(next, themeId);
  const fontId = tpl.settings?.fontId;
  if (typeof fontId === 'string') next = withFunnelFontId(next, fontId);
  return {
    settings: { ...next, templateId: tpl.id } as S & { templateId: string },
    screens: nextScreens,
  };
}
